module.exports = function(bootstrap) {
    bootstrap.run(["Service","$filter", function (Service,$filter) {
        return new Service({
            name: 'claimDetails',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/claims/v1/detail",
            cache: true,
            fetch: function(claim,umi){

                var productLineCodeMap = {
                    "medical": "M",
                    "dental": "D",
                    "vision": false,
                    "drug": "M",
                    // FIXME: Not sure why this is like this.  ods = drug, this doesn't make sense
                    "ods": claim.sysSrcCode
                };
                var productLineCode = productLineCodeMap[claim.sysSrcCode];


                return this.post({
                    payload: {
                        "reqClaimAccumActivityDetail": {
                            "umi": umi,
                            "claimNumber": claim.claimNumber,
                            // clientId is only present in RX claim summary, so it will only be passed for RX detail calls
                            "clientId": claim.clientId,
                            "billingProviderId": claim.bilgProviderId,
                            "callActivitiesV2Flag": claim.callActivitiesV2Flag,
                            "paymentIntegrationFlag": claim.paymentIntegrationFlag,
                            "productLineCode": productLineCode,
                            "includeIgnored": "Yes",
                            "claimSource": "PassThru",
                            "includePassThru": "Yes",
                            "sourceVendor": claim.sourceVendor,
                            "startDate": $filter('date')(new Date() - 740 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            "endDate": $filter('date')(new Date(), 'yyyyMMdd'),
                            "bilgProvClmStaCd": claim.bilgProvClmStaCd,
                            "inputMedium": claim.inputMedium,
                            "clmPartialSupressInd":claim.clmPartialSupressInd
                        }
                    }
                });
            }
        });
    }]);
};
